export default "__VITE_ASSET__834bb5cd__"